import React, { useEffect, useState } from 'react'
import { TableContainer, Table, TableHead, TableCell, TableRow, Paper, TableBody, TextField, Typography, CircularProgress, Button, Card, CardContent, Box, FormControl, Alert } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { postFeedstockMoistureContent, getFeedstockMoistureContent, getFeedstockMoistureContentAverages, downloadDocument } from '../../../../../actions/tigercat-burns/tigercat-actions';
import moment from 'moment';
import { v4 as uuidv4 } from 'uuid';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import useTsPaginator from 'ts-paginator';
import Paginator from '../../../../layout/Pagination';
import { getTableTotalRecordCount } from '../../../../../actions/tigercat-burns/tigercat-base-actions';
import ClearIcon from '@mui/icons-material/Clear';

const FeedstockMc = ({ projectId, project }) => {
    const [feedstockMoistureContentState, setFeedstockMoistureContentState] = useState([])
    const dispatch = useDispatch()
    const feedstockMoistureContents = useSelector(state => state.tigercatBurnsReducer.feedstockMoistureContent?.data)
    const feedstockMoistureContentsAverages = useSelector(state => state.tigercatBurnsReducer.feedstockMoistureContentAverages?.data)
    const currentMaxSampleNumber = useSelector(state => state.tigercatBurnsReducer.feedstockMoistureContent?.max_sample_number)
    const tableRecordCount = useSelector(state => state.tigercatBurnsBaseReducer.totalRecordCount.count)
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState({ dateError: false, percentageError: false })
    const {
        totalRecordCount,
        rowsPerPage,
        currentPage,
        _determinePaginationMessage,
        _determinePaginationDisabledState,
        // _determinePaginationPages,
        _determineRowsPerPageOptions,
        _handleChangeTotalRecordCount,
        _handleChangeRowsPerPage,
        _handleChangePage,
    } = useTsPaginator(+tableRecordCount || 0, 0);
    // const [error, setError] = useState(false)


    useEffect(() => {
        dispatch(getFeedstockMoistureContent(projectId, rowsPerPage, currentPage));
        dispatch(getFeedstockMoistureContentAverages(projectId));
        dispatch(getTableTotalRecordCount('feedstock_moisture_content', projectId));
    }, [dispatch, projectId]);

    useEffect(() => {
        dispatch(getFeedstockMoistureContent(projectId, rowsPerPage, currentPage));
    }, [rowsPerPage, currentPage]);

    useEffect(() => {
        // if (currentProjectId !== projectId) {
        _handleChangePage(0); // Reset to the first page
        _handleChangeRowsPerPage(10)
        _handleChangeTotalRecordCount(+tableRecordCount); // Reset to the first page
        // }
    }, [projectId, tableRecordCount]);

    useEffect(() => {
        const formDataArray = feedstockMoistureContents?.map((item) => {
            const formData = new FormData();
            formData.append('id', item.id);
            formData.append('sampleNumber', item.sampleNumber);
            formData.append('sampleDate', item.sampleDate);
            formData.append('handheldMoistureMeter', item.handheldMoistureMeter);
            formData.append('radwag', item.radwag)
            formData.append('lab', item.lab)
            formData.append('note', item.note)
            return formData;
        });
        setFeedstockMoistureContentState(formDataArray);
    }, [feedstockMoistureContents]);

    const handleAddItem = () => {
        setFeedstockMoistureContentState((prevState) => {
            const state = [...prevState]
            const newRowsCount = state.filter(item => item.get('id') === null || item.get('id') === 'null').length;
            const nextSampleNumber = (currentMaxSampleNumber || 0) + newRowsCount + 1;
            const formData = new FormData();
            formData.append('id', null);
            formData.append('rowId', uuidv4())
            formData.append('sampleNumber', nextSampleNumber);
            formData.append('sampleDate', '');
            formData.append('handheldMoistureMeter', '');
            formData.append('radwag', '');
            formData.append('lab', '');
            formData.append('note', '');
            state.push(formData)
            return state
        })
    }

    const handleDateSelection = (date, rowId) => {
        setFeedstockMoistureContentState((prevState) => {
            return prevState.map((item) => {
                if (item.get('rowId') === rowId || item.get('id') === rowId) {
                    const formattedDate = moment(date).format('YYYY-MM-DD');
                    item.set('sampleDate', formattedDate);
                }
                return item;
            });
        });
    };

    const handleInputChange = (e, rowId, field) => {
        setFeedstockMoistureContentState((prevState) => {
            return prevState.map((item) => {
                if (item.get('rowId') === rowId || item.get('id') === rowId) {
                    item.set(field, e.target.value);
                }
                return item;
            });
        });
    }

    const handleSubmitData = () => {
        setLoading(true)
        let hasDateError = false
        let hasPercentageError = false
        feedstockMoistureContentState.forEach((i) => {
            if (i.get('sampleDate') === '') {
                hasDateError = true
            }
            if (
                i.get('handheldMoistureMeter') === '' &&
                i.get('radwag') === '' &&
                i.get('lab') === ''
            ) {
                hasPercentageError = true
            }
            setError({ dateError: hasDateError, percentageError: hasPercentageError });
            if (hasDateError || hasPercentageError) {
                return
            }
        })
        if (!hasDateError || !hasPercentageError) {
            dispatch(postFeedstockMoistureContent(projectId, feedstockMoistureContentState)).then(() => {
                dispatch(getFeedstockMoistureContent(projectId, rowsPerPage, currentPage)).then(() => {
                    dispatch(getFeedstockMoistureContentAverages(projectId)).then(() => {
                        dispatch(getTableTotalRecordCount('feedstock_moisture_content', projectId)).then(() => {
                            setLoading(false)
                            setError(false)
                        })
                    })
                })
            })
        } else {
            setLoading(false)
        }
    }

    const handleClearEntry = (rowIdToRemove) => {
        setFeedstockMoistureContentState((prevState) =>
            prevState.filter((item) => item.get('rowId') !== rowIdToRemove)
        );
    }

    const handleDownload = async () => {
        try {
            dispatch(downloadDocument(projectId, 'feedstock_moisture_content')).then((response) => {

                // Create a downloadable link for the Excel file
                const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `${project}_feedstock_moisture_content.xlsx`); // Set the file name
                document.body.appendChild(link);
                link.click();
                link.remove();
            })

        } catch (err) {
            console.error('Error downloading Feedstock Moisture Content:', err);
        }
    };

    const card = (
        <Card>
            <CardContent>
                <Typography variant="h5" component="div" sx={{ fontWeight: 'bold' }}>
                    Feedstock Moisture Content
                </Typography>
                <Typography sx={{ color: 'text.secondary', mb: 1.5 }}>Averages</Typography>
                <TableContainer sx={{ maxWidth: '50%' }} component={Paper}>
                    <Table aria-label="simple table">
                        <TableHead>
                            <TableRow>
                                <TableCell align="left">
                                    Description
                                </TableCell>
                                <TableCell align="left">
                                    Number of Samples
                                </TableCell>
                                <TableCell align="left">
                                    Average Moisture Content (%)
                                </TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            <TableRow>
                                <TableCell align="left"><b>Average Handheld Moisture Meter:</b></TableCell>
                                <TableCell align="left">{feedstockMoistureContentsAverages?.handheld_moisture_meter?.num_samples}</TableCell>
                                <TableCell align="left">{feedstockMoistureContentsAverages?.handheld_moisture_meter?.average}</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell align="left"><b>Average Radwag:</b></TableCell>
                                <TableCell align="left">{feedstockMoistureContentsAverages?.radwag?.num_samples}</TableCell>
                                <TableCell align="left">{feedstockMoistureContentsAverages?.radwag?.average}</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell align="left"><b>Average Lab Test:</b></TableCell>
                                <TableCell align="left">{feedstockMoistureContentsAverages?.lab?.num_samples}</TableCell>
                                <TableCell align="left">{feedstockMoistureContentsAverages?.lab?.average}</TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </TableContainer>
            </CardContent>
        </Card>
    );

    return (<>
        <Box sx={{ mb: 2 }}>
            {card}
        </Box>
        <h2>Feedstock Moisture Content</h2>
        <TableContainer key={0} component={Paper} >
            <Button variant='contained' sx={{ height: 'auto', float: 'right', mt: 2, mb: 2 }} onClick={handleDownload}>Download Excel</Button>

            <Table aria-label="simple table">
                <TableHead>
                    <TableRow>
                        <TableCell size="small" align="left">Date</TableCell>
                        <TableCell size="small" align="left">Sample Number</TableCell>
                        <TableCell size="small" align="left">Handheld Moisture Meter (%)</TableCell>
                        <TableCell size="small" align="left">Radwag (%)</TableCell>
                        <TableCell size="small" align="left">Lab (%)</TableCell>
                        <TableCell size="small" align="left">Note</TableCell>
                        <TableCell size="small" align="left">Remove Row</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {feedstockMoistureContentState?.map((data, index) => {
                        return (
                            <TableRow key={index}>
                                <TableCell size="small" align="left">
                                    <FormControl>
                                        <LocalizationProvider dateAdapter={AdapterMoment}>
                                            <DatePicker
                                                name={'date'}
                                                value={data.get('sampleDate') ? moment(data.get('sampleDate'), 'YYYY-MM-DD') : null}
                                                onChange={(e) => {
                                                    let idArgument = JSON.parse(data.get('id')) === null ? data.get('rowId') : data.get('id')
                                                    handleDateSelection(e.toDate(), idArgument)
                                                }}
                                                disabled={data.get('disabled') ?? false}
                                                format="MM/DD/YYYY"
                                            />
                                        </LocalizationProvider>
                                    </FormControl>
                                </TableCell>
                                <TableCell size="small" align="left">
                                    {data.get('sampleNumber')}
                                </TableCell>
                                <TableCell size="small" align="left">
                                    <TextField
                                        name='handheldMoistureMeter'
                                        value={data.get('handheldMoistureMeter')}
                                        onChange={(e) => {
                                            let idArgument = JSON.parse(data.get('id')) === null ? data.get('rowId') : data.get('id')
                                            handleInputChange(e, idArgument, 'handheldMoistureMeter')
                                        }
                                        }
                                        type="number"
                                        disabled={data.get('disabled') ?? false}
                                    />
                                </TableCell>
                                <TableCell size="small" align="left">
                                    <TextField
                                        name='radwag'
                                        value={data.get('radwag')}
                                        onChange={(e) => {
                                            let idArgument = JSON.parse(data.get('id')) === null ? data.get('rowId') : data.get('id')
                                            handleInputChange(e, idArgument, 'radwag')
                                        }}
                                        type="number"
                                        disabled={data.get('disabled') ?? false}
                                    />
                                </TableCell>
                                <TableCell size="small" align="left">
                                    <TextField
                                        name='lab'
                                        value={data.get('lab')}
                                        onChange={(e) => {
                                            let idArgument = JSON.parse(data.get('id')) === null ? data.get('rowId') : data.get('id')
                                            handleInputChange(e, idArgument, 'lab')
                                        }}
                                        type="number"
                                        disabled={data.get('disabled') ?? false}
                                    />
                                </TableCell>
                                <TableCell size="small" align="left">
                                    <TextField
                                        name='note'
                                        value={data.get('note') === 'null' ? '' : data.get('note')}
                                        onChange={(e) => {
                                            let idArgument = JSON.parse(data.get('id')) === null ? data.get('rowId') : data.get('id')
                                            handleInputChange(e, idArgument, 'note')
                                        }}
                                        type="text"
                                        disabled={data.get('disabled') ?? false}
                                    />
                                </TableCell>
                                <TableCell size="small" align="left">
                                    {data.get('rowId') && index === feedstockMoistureContentState.length - 1 ? (
                                        <Box onClick={() => handleClearEntry(data.get('rowId'))}
                                            sx={{ cursor: 'pointer', color: 'red', mt: 1 }}>
                                            <ClearIcon />
                                        </Box>
                                    ) : null}
                                </TableCell>
                            </TableRow>
                        )
                    })}
                </TableBody>
            </Table>
        </TableContainer>
        <Paginator
            totalRecordCount={totalRecordCount}
            rowsPerPage={rowsPerPage}
            currentPage={currentPage}
            handleChangePage={_handleChangePage}
            handleChangeRowsPerPage={_handleChangeRowsPerPage}
            determinePaginationMessage={_determinePaginationMessage}
            determinePaginationDisabledState={_determinePaginationDisabledState}
            determineRowsPerPageOptions={_determineRowsPerPageOptions}
        />
        {error.dateError ? <Alert severity='error' sx={{ my: 1 }}>Sample date is a required field</Alert> : null}
        {error.percentageError ? <Alert severity='error' sx={{ my: 1 }}>At least one Handheld Moisture Meter (%), Radwag (%) or Lab (%) is required</Alert> : null}

        <Box sx={{ position: 'relative', mb: 10 }}>
            {loading ?
                <CircularProgress sx={{ position: 'absolute', left: '125px', top: '12px' }}></CircularProgress>
                :
                <Box>
                    <Button variant='contained' sx={{ height: 'auto', mt: 2, mr: 2 }} onClick={handleAddItem}>Add Entry</Button>
                    <Button variant='contained' sx={{ height: 'auto', mt: 2 }} onClick={handleSubmitData}>Submit Data</Button>
                </Box>}
        </Box>
    </>
    )
}

export default FeedstockMc